import {
  CLEAR_MASCOTAS_ACTION,
  FETCH_MASCOTAS,
  DELETE_MASCOTA,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
  CLEAR_MASCOTAS,
  FETCHED_MASCOTAS,
  FETCHING_MASCOTAS,
  CLEAR_MASCOTAS_INFO,
  SET_MASCOTA,
  FETCHING_MASCOTA,
  FETCHED_MASCOTA,
  SUBMITED_MASCOTA,
  SUBMIT_MASCOTA_ERROR,
  SUBMITED_MASCOTA_DELETE,
  RESET_MASCOTA_SUBMIT,
  RESET_MASCOTA_PROCESSING,
  STARTED_MASCOTA_PROCESSING,
  SHOW_AVISO_PRIVACIDAD,
} from './mutations.type';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_mascotas: false,
  loading_mascota: false,
  processing_mascota: false,
  submited_mascota: false,
};

const getters = {
  is_loading() {
    return state.loading_mascotas;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  mascota_processing() {
    return state.processing_mascota;
  },
  mascota_submited() {
    return state.submited_mascota;
  },
};

const actions = {
  [DELETE_MASCOTA](context, mascotaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.delete(`mascotas/${mascotaId}`)
        .then(({ data }) => {
          context.commit(SUBMITED_MASCOTA_DELETE);
          resolve(data);
          // context.dispatch(FETCH_MASCOTAS);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_MASCOTA_ERROR, [response.data.message]);
        });
    });
  },
  [SHOW_AVISO_PRIVACIDAD](context, mascotaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_MASCOTA);
      const url = `mascotas/acuerdo_mascota/${mascotaId}`;
      ApiService.queryBlob(url)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(FETCHED_MASCOTA);
          resolve(buffer);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_MASCOTA);
        });
    });
  },
  [FETCH_MASCOTAS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_MASCOTAS);
      ApiService.post('mascotas/listado_mascotas', data)
        .then(({ data }) => {
          context.commit(FETCHED_MASCOTAS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_MASCOTAS);
        });
    });
  },
  [CLEAR_MASCOTAS_ACTION](context) {
    context.commit(CLEAR_MASCOTAS);
  },
};

const mutations = {
  [SUBMITED_MASCOTA_DELETE](state) {
    state.alert = true;
    state.alertMessage = 'Mascota Eliminada Correctamente';
    state.alertType = 'success';
    state.submited_mascota = true;
  },
  [FETCHING_MASCOTAS](state) {
    state.loading_mascotas = true;
  },
  [FETCHED_MASCOTAS](state) {
    state.loading_mascotas = false;
  },
  [CLEAR_MASCOTAS_INFO](state) {
    state.mascotas_info = {};
  },
  [SET_MASCOTA](state, data) {
    state.mascota_info = data.mascota;
  },
  [FETCHING_MASCOTA](state) {
    state.loading_mascota = true;
  },
  [FETCHED_MASCOTA](state) {
    state.loading_mascota = false;
  },
  [SUBMITED_MASCOTA](state, data) {
    state.submited_mascota = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_MASCOTA_ERROR](state, data) {
    state.processing_mascota = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_MASCOTA_SUBMIT](state) {
    state.submited_masscota = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_MASCOTA_PROCESSING](state) {
    state.processing_mascota = false;
  },
  [STARTED_MASCOTA_PROCESSING](state) {
    state.processing_mascota = true;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
